import { render, staticRenderFns } from "./EdlordersBuy.vue?vue&type=template&id=e15076a8&"
import script from "./EdlordersBuy.vue?vue&type=script&lang=js&"
export * from "./EdlordersBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports